import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=76a7738e&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"
import style0 from "./Form.vue?vue&type=style&index=0&id=76a7738e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a7738e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76a7738e')) {
      api.createRecord('76a7738e', component.options)
    } else {
      api.reload('76a7738e', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=76a7738e&scoped=true", function () {
      api.rerender('76a7738e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/SearchModal/Form.vue"
export default component.exports